import type { GetAppetiteAuditByIdResponseRow } from '@risksmart-app/drizzle/src/types';
import { GetAppetiteAuditByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

import type { AuditLogQueryResult } from './auditLogQueryResult';

type UseGetAppetiteAuditByIdArgs = {
  id: string;
};

export const useGetAppetiteAuditById = createQueryHook<
  UseGetAppetiteAuditByIdArgs,
  GetAppetiteAuditByIdResponseRow[],
  AuditLogQueryResult<
    'appetite_audit',
    GetAppetiteAuditByIdResponseRow,
    'Statement'
  >
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.auditLog.getAppetiteAuditById.queryOptions({
      id,
    }),
  mapTrpcDataToGraphQL: (data) => ({ appetite_audit: data }),
  graphqlDocument: GetAppetiteAuditByIdDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
});
